"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepthVideoFrame = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
const DepthImageFrame_1 = require("./DepthImageFrame");
let DepthVideoFrame = class DepthVideoFrame extends DepthImageFrame_1.DepthImageFrame {
};
exports.DepthVideoFrame = DepthVideoFrame;
exports.DepthVideoFrame = DepthVideoFrame = tslib_1.__decorate([
    (0, core_1.SerializableObject)()
], DepthVideoFrame);
//# sourceMappingURL=DepthVideoFrame.js.map